import axios from 'axios';
import jsonp from 'jsonp';

axios.defaults.headers.common['X-L-REQ-HEADER'] = '{deviceType:1}'; // for all requests （对于所有的请求）
axios.defaults.withCredentials = true; // carry cookie（携带 cookie）

axios.interceptors.response.use((response) => {
    if (response.data && response.data.state === 1111) {
        if (sessionStorage.getItem('bodyHasDialog')) {
            return Promise.reject();
        }
        sessionStorage.setItem('bodyHasDialog', 1);
        sessionStorage.setItem('otherIp', response.data.message);
        window.open(`${window.location.origin}/frontLogout.do`, '_self');
        return Promise.reject();
    }
    return response;
}, (error) => {
    return Promise.reject(error);
});

// 添加请求拦截器
axios.interceptors.request.use(function (request) {
    // 在发送请求之前做些什么
    return request;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });


export function fetchGet(url, params = {}, config = {}) {
    return new Promise((resolve, reject) => {
        config.params = params;
        axios.get(url, config).then(res => {
            resolve(res.data);
        }).catch((error) => {
            reject(error);
        });
    });
}

export function fetchPost(url, data = {}, config = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data, config).then(res => {
            resolve(res.data);
        }).catch((error) => {
            reject(error);
        });
    });
}

export function fetchJsonp(url, params) {
    let requestUrl = url;
    if (params) {
        params._ = Date.parse(new Date());
        const dataString = url.indexOf('?') === -1 ? '?' : '&';
        requestUrl = `${requestUrl}${dataString}`;
        for (const k in params) {
            requestUrl += `&${k}=${params[k]}`;
        }
    }
    return new Promise((resolve, reject) => {
        jsonp(requestUrl, { param: 'jsoncallback' }, (err, res) => {
            if (err) {
                reject(err);
            } else {
                resolve(res);
            }
        });
    });
}

export default axios;
